import React from 'react';

export const LoginContext = React.createContext();


// WEBPACK FOOTER //
// ./src/Components/Login/LoginContext.js